import { render } from "./StaffLogin.vue?vue&type=template&id=4cfa2276&scoped=true"
import script from "./StaffLogin.vue?vue&type=script&lang=js"
export * from "./StaffLogin.vue?vue&type=script&lang=js"

import "./StaffLogin.vue?vue&type=style&index=0&id=4cfa2276&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cfa2276"]])

export default __exports__